import React, { useState, useEffect, useRef } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import axios from "axios";
import Snackbar from "@mui/material/Snackbar";

const apiUrl = process.env.REACT_APP_API_URL;

export default function EmailSendDialog({
  visible,
  onHide,
  leadData,
  type = "devis",
  onSnackbarMessage,
  onOpenSnackbar,
  onSent,
}) {
  const [loadingTemplate, setLoadingTemplate] = useState(false);
  const [sending, setSending] = useState(false);
  const [sujet, setSujet] = useState("");
  const [corps, setCorps] = useState("");
  const [destEmail, setDestEmail] = useState("");
  const [lienPdf, setLienPdf] = useState("");
  const [saveAsTemplate, setSaveAsTemplate] = useState(false);
  const [loadError, setLoadError] = useState("");
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [originalTemplate, setOriginalTemplate] = useState({ sujet: "", corps: "" });
  const [replacements, setReplacements] = useState({});
  const previewRef = useRef(null);

  const endpoint = type === "relance" ? "sendMailRelanceDevis.php" : "sendMailDevis.php";
  const title = type === "relance" ? "Relancer par email" : "Envoyer le devis par email";

  // Styles CSS injectés
  useEffect(() => {
    const style = document.createElement('style');
    style.textContent = `
      .email-dialog .p-dialog-content {
        padding: 1.5rem;
        color: #1f2937;
        font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
      }
      .email-dialog .field-label {
        font-size: 12px;
        color: #6b7280;
        display: block;
        margin-bottom: 4px;
        font-weight: 500;
        text-transform: uppercase;
        letter-spacing: 0.05em;
      }
      .email-dialog .clean-input {
        width: 100%;
        height: 38px;
        padding: 0 12px;
        border: 1px solid #e5e7eb;
        border-radius: 6px;
        background-color: #ffffff;
        font-size: 13.5px;
        color: #322915;
        transition: border-color 0.15s ease;
        box-sizing: border-box;
      }
      .email-dialog .clean-input:focus {
        outline: none;
        border-color: #322915;
      }
      .email-dialog .brand-btn-primary {
        background-color: #322915 !important;
        border-color: #322915 !important;
        color: #ffffff !important;
        border-radius: 6px !important;
        font-weight: 500 !important;
      }
      .email-dialog .brand-btn-primary:hover {
        opacity: 0.9;
      }
      .email-dialog .btn-outlined-clean {
        border-color: #e5e7eb !important;
        color: #322915 !important;
        font-size: 13px !important;
        border-radius: 6px !important;
      }
      .email-dialog .btn-outlined-clean:hover {
        background-color: #f9fafb !important;
      }
      .email-dialog .preview-editable {
        border: 1px solid #e5e7eb;
        border-radius: 6px;
        padding: 14px;
        min-height: 200px;
        max-height: 450px;
        overflow-y: auto;
        background: #ffffff;
        font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
        font-size: 14px;
        line-height: 1.6;
        color: #1f2937;
        outline: none;
        transition: border-color 0.15s ease;
      }
      .email-dialog .preview-editable:focus {
        border-color: #322915;
        box-shadow: 0 0 0 2px rgba(50, 41, 21, 0.1);
      }
      .email-dialog .preview-editable img {
        max-width: 100%;
      }
      .email-dialog .preview-editable a {
        color: #322915;
        text-decoration: underline;
      }
      .email-dialog .preview-editable a:hover {
        color: #dfb02f;
      }
      .email-dialog .preview-editable p {
        margin: 0 0 10px 0;
      }
      .email-dialog .preview-editable p:last-child {
        margin-bottom: 0;
      }
      .email-dialog .email-info {
        background: #fafafa;
        padding: 10px 12px;
        border-radius: 6px;
        border: 1px solid #e5e7eb;
        font-size: 13.5px;
        color: #322915;
      }
      .email-dialog .email-info-label {
        font-size: 11px;
        color: #6b7280;
        margin-bottom: 2px;
      }
      .email-dialog .switch-wrapper {
        display: flex;
        align-items: center;
        gap: 2px;
      }
      .email-dialog .switch-wrapper input[type="checkbox"] {
        width: 38px;
        height: 20px;
        accent-color: #322915;
        cursor: pointer;
      }
      .email-dialog .switch-label {
        font-size: 12.5px;
        color: #322915;
      }
      .email-dialog .pdf-info {
        font-size: 12px;
        color: #6b7280;
        display: flex;
        align-items: center;
        gap: 6px;
        background: #fafafa;
        padding: 8px 12px;
        border-radius: 6px;
        border: 1px solid #e5e7eb;
      }
      .email-dialog .pdf-info i {
        color: #322915;
      }
      .email-dialog .toolbar {
        display: flex;
        gap: 4px;
        padding: 6px 10px;
        background: #fafafa;
        border: 1px solid #e5e7eb;
        border-radius: 6px 6px 0 0;
        border-bottom: none;
        flex-wrap: wrap;
        align-items: center;
      }
      .email-dialog .toolbar button {
        background: none;
        border: 1px solid transparent;
        border-radius: 4px;
        padding: 4px 8px;
        font-size: 13px;
        color: #322915;
        cursor: pointer;
        transition: all 0.15s ease;
        display: flex;
        align-items: center;
        gap: 4px;
        height: 28px;
      }
      .email-dialog .toolbar button:hover {
        background: #ffffff;
        border-color: #e5e7eb;
      }
      .email-dialog .toolbar button i {
        font-size: 14px;
      }
      .email-dialog .toolbar .separator {
        width: 1px;
        height: 24px;
        background: #e5e7eb;
        margin: 0 4px;
      }
      .email-dialog .editor-wrapper {
        border: 1px solid #e5e7eb;
        border-radius: 6px;
        overflow: hidden;
      }
      .email-dialog .editor-wrapper .preview-editable {
        border: none;
        border-radius: 0;
      }
      .email-dialog .editor-wrapper .preview-editable:focus {
        box-shadow: none;
      }
      .email-dialog .toolbar .btn-bold {
        font-weight: 700;
      }
      .email-dialog .toolbar .btn-italic {
        font-style: italic;
      }
      .email-dialog .toolbar .btn-underline {
        text-decoration: underline;
      }
    `;
    document.head.appendChild(style);
    return () => document.head.removeChild(style);
  }, []);

  useEffect(() => {
    if (visible && leadData?.idLead) {
      loadTemplate();
    }
  }, [visible, leadData, type]);

  useEffect(() => {
    if (!loadingTemplate && corps && previewRef.current) {
      previewRef.current.innerHTML = corps;
    }
  }, [loadingTemplate, corps]);

  const loadTemplate = async () => {
    setLoadingTemplate(true);
    setLoadError("");
    setSaveAsTemplate(false);
    try {
      const res = await axios.get(`${apiUrl}/IHM/api/apiMail/get_email_template.php`, {
        params: { lead_id: leadData.idLead, type },
      });
      if (res.data.success) {
        setSujet(res.data.sujet);
        setCorps(res.data.corps);
        setDestEmail(res.data.email);
        setLienPdf(res.data.lien_pdf || "");
        setOriginalTemplate({
          sujet: res.data.sujet_brut || res.data.sujet,
          corps: res.data.corps_brut || res.data.corps
        });
        setReplacements(res.data.replacements || {});
      } else {
        setLoadError(res.data.message || "Impossible de charger le modèle");
      }
    } catch (err) {
      console.error("Erreur chargement modèle:", err);
      setLoadError("Impossible de charger le modèle d'email");
    } finally {
      setLoadingTemplate(false);
    }
  };

  const restorePlaceholders = (htmlString) => {
    const doc = new DOMParser().parseFromString(htmlString, "text/html");

    // variables textuelles
    doc.querySelectorAll("[data-v]").forEach((el) => {
      el.replaceWith(`{{${el.getAttribute("data-v")}}}`);
    });

    // lien du devis
    doc.querySelectorAll("[data-v-href]").forEach((el) => {
      el.setAttribute("href", `{{${el.getAttribute("data-v-href")}}}`);
      el.removeAttribute("data-v-href");
    });

    return doc.body.innerHTML;
  };


  const restoreSujet = (text, replacementsMap) => {
    let result = text;
    Object.entries(replacementsMap || {})
      .filter(([, v]) => v)
      .sort(([, a], [, b]) => String(b).length - String(a).length)
      .forEach(([ph, v]) => {
        result = result.split(String(v)).join(ph);
      });
    return result;
  };

  const execCommand = (command, value = null) => {
    document.execCommand(command, false, value);
    if (previewRef.current) {
      previewRef.current.focus();
    }
  };

  const insertLink = () => {
    const url = window.prompt("Entrez l'URL du lien:", "https://");
    if (url) {
      execCommand('createLink', url);
    }
  };

  const handleSend = async () => {
    const contentToSend = previewRef.current ? previewRef.current.innerHTML : corps;

    if (!sujet.trim() || !contentToSend.trim()) {
      setSnackbarMessage("Le sujet et le message ne peuvent pas être vides");
      setOpenSnackbar(true);
      return;
    }

    setSending(true);
    try {
      if (saveAsTemplate) {
        await axios.post(`${apiUrl}/IHM/api/apiMail/save_email_template.php`, {
          type,
          sujet: restoreSujet(sujet, replacements),
          corps: restorePlaceholders(contentToSend),
        });
      }

      const res = await axios.post(`${apiUrl}/IHM/api/apiMail/${endpoint}`, {
        id: leadData.idLead,
        adminMod: localStorage.getItem("us"),
        sujet,
        corps: contentToSend,
      });

      if (res.data.success) {
        setSnackbarMessage(res.data.message || `Email envoyé à ${destEmail}`);
        setOpenSnackbar(true);
        setTimeout(() => {
          onHide();
          if (onSent) onSent();
          else window.location.reload();
        }, 1500);
      } else {
        setSnackbarMessage(res.data.message || "Envoi impossible");
        setOpenSnackbar(true);
      }
    } catch (err) {
      console.error("Erreur envoi mail:", err);
      setSnackbarMessage("Impossible d'envoyer l'email");
      setOpenSnackbar(true);
    } finally {
      setSending(false);
    }
  };

  const handleCloseSnackbar = () => setOpenSnackbar(false);

  const header = (
    <div className="flex justify-content-between align-items-center w-full">
      <span className="font-semibold text-lg" style={{ color: "#322915" }}>
        {title}
      </span>
    </div>
  );

  return (
    <>
      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        open={openSnackbar}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
        message={snackbarMessage}
        action={
          <IconButton size="small" color="inherit" onClick={handleCloseSnackbar}>
            <CloseIcon fontSize="small" />
          </IconButton>
        }
      />

      <Dialog
        blockScroll
        visible={visible}
        header={header}
        className="email-dialog"
        style={{ width: "48vw", maxWidth: "720px" }}
        modal
        onHide={onHide}
        breakpoints={{ "960px": "90vw", "640px": "95vw" }}
      >
        {loadingTemplate ? (
          <div className="flex justify-content-center p-4">
            <i className="pi pi-spin pi-spinner" style={{ fontSize: "1.4rem", color: "#322915" }}></i>
          </div>
        ) : loadError ? (
          <div style={{ color: "#b91c1c", fontSize: "13.5px", padding: "12px 0" }}>
            {loadError}
          </div>
        ) : (
          <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
            {/* Destinataire */}
            <div>
              <label className="field-label">Destinataire</label>
              <div className="email-info">
                <div className="email-info-label">Email</div>
                <div>{destEmail}</div>
              </div>
            </div>

            {/* Sujet */}
            <div>
              <label className="field-label">Sujet</label>
              <input
                className="clean-input"
                value={sujet}
                onChange={(e) => setSujet(e.target.value)}
                placeholder="Sujet de l'email"
              />
            </div>

            {/* Message éditable */}
            <div>
              <label className="field-label" style={{ marginBottom: "6px" }}>
                Message (cliquez directement dans le texte pour l'éditer)
              </label>

              <div className="editor-wrapper">
                {/* Barre d'outils */}
                <div className="toolbar">
                  <button onClick={() => execCommand("bold")} title="Gras" className="btn-bold">
                    <b>B</b>
                  </button>
                  <button onClick={() => execCommand("italic")} title="Italique" className="btn-italic">
                    <i>I</i>
                  </button>
                  <button onClick={() => execCommand("underline")} title="Souligné" className="btn-underline">
                    <u>U</u>
                  </button>

                  <div className="separator"></div>

                  <button onClick={() => execCommand("insertUnorderedList")} title="Liste à puces">
                    <i className="pi pi-list"></i>
                  </button>
                  <button onClick={() => execCommand("insertOrderedList")} title="Liste numérotée">
                    <i className="pi pi-sort-alt"></i>
                  </button>

                  <div className="separator"></div>

                  <button onClick={insertLink} title="Insérer un lien">
                    <i className="pi pi-link"></i>
                  </button>

                  <div className="separator"></div>

                  <button onClick={() => execCommand("removeFormat")} title="Supprimer le formatage">
                    <i className="pi pi-eraser"></i>
                  </button>
                </div>

                {/* Zone éditable */}
                <div
                  ref={(el) => {
                    previewRef.current = el;
                    if (el && corps && !el.innerHTML) {
                      el.innerHTML = corps;
                    }
                  }}
                  className="preview-editable"
                  contentEditable
                  suppressContentEditableWarning={true}
                />
              </div>
              
            </div>

            {/* PDF joint */}
            {/* {lienPdf && (
              <div className="pdf-info">
                <i className="pi pi-paperclip"></i>
                <span>Le PDF du devis sera joint automatiquement à l'envoi.</span>
              </div>
            )} */}

            {/* Enregistrer comme modèle */}
            <div className="switch-wrapper">
              <input
                type="checkbox"
                checked={saveAsTemplate}
                onChange={(e) => setSaveAsTemplate(e.target.checked)}
              />
              <span className="switch-label">
                Enregistrer ce texte comme modèle par défaut pour les prochains envois
              </span>
            </div>

            {/* Boutons d'action */}
            <div style={{ display: "flex", justifyContent: "flex-end", gap: "8px", marginTop: "4px" }}>
              <Button
                label="Annuler"
                outlined
                className="btn-outlined-clean"
                onClick={onHide}
                disabled={sending}
              />
              <Button
                label={sending ? "Envoi en cours..." : "Envoyer"}
                icon={!sending ? "pi pi-send" : ""}
                className="brand-btn-primary"
                onClick={handleSend}
                disabled={sending}
                style={{ fontSize: "13px", padding: "0 20px" }}
              />
            </div>
          </div>
        )}
      </Dialog>
    </>
  );
}